import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Icons from '../../../Elements/Icons';
const UploadingErrorStyle = styled.div `
  color: ${({ theme }) => theme.colors.critical70};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 4px;
  margin: 4px 0;
`;
export const UploadingError = ({ children }) => (_jsxs(UploadingErrorStyle, { "data-testid": 'uploading-error', children: [_jsx(Icons.WarningCircleAlt, { size: 20, color: 'currentColor' }), children] }));
